import apiClient from './client';

/**
 * List the child's handcraft submissions for a session, along with the
 * currently assigned Handcraft, attempt counters, and skip-eligibility flags.
 */
export const fetchHandcraftSubmissions = async (sessionId) => {
  const response = await apiClient.get(
    `/activity_sessions/${sessionId}/handcraft_submissions`
  );
  return response.data;
};

/**
 * Upload a photo of the finished craft. The backend grades it against the
 * Handcraft reference image via OpenAI and returns the resulting submission.
 */
export const createHandcraftSubmission = async (sessionId, photoFile) => {
  const formData = new FormData();
  formData.append('photo', photoFile);

  try {
    const response = await apiClient.post(
      `/activity_sessions/${sessionId}/handcraft_submissions`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 422) {
      return error.response.data;
    }
    throw error;
  }
};
